function ClosestSpot() {
	this.node = $("<div><div style='position: absolute;width: 160px; height: 160px;background-color: #ffffff00;bpx-sizing:border-box; border: 3px solid rgba(255, 255, 255, 0.5);border-radius: 100%'></div></div>");
	$("#hotspots").append(this.node);
	this.proceedcd = 0;
	this.visible = false;
	this.last = {};
	this.visibility = 0;
}

ClosestSpot.prototype = {

	show: function() {
		Tab.reset();
		this.visible = true;
	},

	hide: function() {
		this.visible = false;
	},

	resetDistance: function() {
		this.node.hide();
		this.d = 9999999999;
	},

	setDistance: function(dd) {
		this.d = dd;
	},

	setSpot: function(s) {
		//console.log(this.d);
		try {
			if (s != undefined && s != null) {
				//if (this.tm != undefined) clearTimeout(this.tm);
				//this.tm = setTimeout(function() {s.speakTitle();}, 20);
				if (this.visible && this.shouldspeak != undefined && (Date.now() - this.shouldspeak) < 500) {
					s.speakTitle();
				}
			}

			this.visibility = 0;
			var disp = "";

			if (s != null) {
				if (!player.cms) {
					if (this.last != s && this.last.idc != undefined && this.last.idc.hide == "2") this.last.node.hide();
				}

				if (s.idc != undefined && s.idc.hide != "0") {
					//disp = "display:none; ";
					this.node.hide();
				}

				if (this.last.tag != s.tag) {
					if (s.tag == 'indicator') {
						this.node.html("<div style='" + disp + "position: absolute;width: 80px; height: 70px;background-color: #ffffff00;bpx-sizing:border-box; border: 3px solid rgba(255, 255, 255, 0.7);border-radius: 15px;top: -20px;left:-10px'></div>");
					} else {
						this.node.html("<div style='position: absolute;width: 160px; height: 160px;background-color: #ffffff00;bpx-sizing:border-box; border: 3px solid rgba(255, 255, 255, 0.5);border-radius: 100%'></div>");
					}
				}

				
				this.last = s;
			}

			if (this.last.idc != undefined) this.visibility = this.last.idc.hide;

			/*
			if (s != undefined && s != null && this.spoken != s.properties.place.speech_title) { //} && Math.abs(this.d) < 26000) {
//			if (s != undefined && s != null && this.spot.properties.place.speech_title != s.properties.place.speech_title && this.d < 5000) {
				//console.log(this.spot.properties.place.speech_title + " = " + s.properties.place.speech_title);
				//console.log(this.spot.properties.place.place_name + " = " + s.properties.place.place_name);
				this.spoken = s.properties.place.speech_title;

				if (this.shouldspeak != undefined && (Date.now() - this.shouldspeak) < 500) {
					s.speakTitle();
					this.shouldspeak = Date.now();
				}
			}
			*/
		} catch(e) {
			console.log(e);
		}

		this.spot = s;
	},

	speak: function() {
		this.shouldspeak = Date.now();
	},

	setCoords: function(pt) {
		//return;

		//console.log(pt);
		
		if (this.visibility == "1" || this.visibility == "2") {
			this.node.hide();
			if (!player.cms) {
				if (this.visible && this.visibility == "2") this.last.node.show();
				else this.last.node.hide();
			}
		} else if (this.visible) this.node.show();

//		this.node.css("transform", "translate(" + (pt.x - 28) + "px, " + (pt.y - 28) + "px)");
		this.node.css("transform", "translate(" + (pt.x - 78) + "px, " + (pt.y - 78) + "px)");
//		this.node.css("left", pt.x + "px");
//		this.node.css("top", pt.y + "px");
	},

	proceed: function() {
		//return;
		
		if (this.spot != undefined && this.proceedcd == 0) {
				
			this.proceedcd = 1;
			this.spot.proceed(true);

			var self = this;
			setTimeout(function() {
				self.proceedcd = 0;
			}, 500);
		}
	}
}